// Minimal feature flag helper
// Usage: ff(predicateFn, params) → boolean
// Example: ff(({ userType }) => userType === 'super-admin', { userType })
export const ff = (predicate, params = {}) => {
    try {
        return Boolean(typeof predicate === 'function' ? predicate(params) : false)
    } catch (_) {
        return false
    }
}

// Central registry for reusable flag predicates
// Define all your app's flag predicates here and reuse across the app
export const flags = {
    canAccessAthleteListCoachFilter: ({ userType }) => (userType === 'super-admin' || userType === 'organization-admin' || userType === 'organization-owner'),
    canAccessBillingSettings: ({ userType }) => (userType === 'super-admin' || userType === 'organization-admin' || userType === 'organization-owner'),
    canApplyOneOffCoachOverrides: ({ profileType }) => (profileType === 'group' || profileType === 'individual'),
    canEditKinesisProfileEquipmentProfile: ({ profileType }) => (profileType === 'group' || profileType === 'individual'),
    canEditKinesisProfileEvents: ({ profileType }) => (profileType === 'group' || profileType === 'individual'),
    canEditKinesisProfileFitnessProfile: ({ profileType }) => (profileType === 'group' || profileType === 'individual'),
    canEditKinesisProfileInjuries: ({ profileType }) => (profileType === 'group' || profileType === 'individual'),
    canEditKinesisProfileWeekDaySchedules: ({ profileType }) => (profileType === 'group' || profileType === 'individual'),
    canAccessKinesisUserGroups: ({ userType, enableKinesisUserGroups }) => (userType === 'super-admin' || enableKinesisUserGroups === 1),
    canAccessOrganzationInfoSettings: ({ userType }) => (userType === 'super-admin' || userType === 'organization-admin' || userType === 'organization-owner'),
    canAccessSidebarAdminTools: ({ userType, adminToolsVisible }) => (userType === 'super-admin' && adminToolsVisible === true),
    canAccessSidebarSalesTools: ({ userType, adminToolsVisible }) => (userType === 'super-admin' && adminToolsVisible === true),
    canAssignGroupOwner: ({ userType }) => (userType === 'super-admin' || userType === 'organization-admin' || userType === 'organization-owner'),
    canAssignTrainer: ({ userType }) => (userType === 'super-admin' || userType === 'organization-admin' || userType === 'organization-owner'),
    canChangeRoles: ({ userType }) => (userType === 'super-admin' || userType === 'organization-admin' || userType === 'organization-owner'),
    canRunWorkouts: ({ userType, enableCoachRunningWorkouts }) => (userType === 'super-admin' || enableCoachRunningWorkouts === 1),
    emailRequiredWhenCreatingAthletes: ({ requireEmailToCreateAthleteAccount }) => (requireEmailToCreateAthleteAccount === 1),
}

// Helper to extend/override flags at runtime (optional)
// Usage: defineFlags({ myNewFlag: (p) => true })
export const defineFlags = (newFlags = {}) => {
    Object.assign(flags, newFlags)
    return flags
}

// Role based option helpers

export const GetCoachRoleOptions = (userType) => {

    const roleOptions = [
        {
            key: 'super-admin',
            label: 'Super Admin',
            description: 'Access to all permissions. Reserved for internal Kinesis team only.',
            rolesAllowedToSelectThisOption: []
        },
        {
            key: 'organization-owner',
            label: 'Orgnaization Owner',
            description: 'Access to all athletes in the organization. Access to all organization settings. Cannot be demoted to a lower role by organization admins.',
            rolesAllowedToSelectThisOption: []
        },
        {
            key: 'organization-admin',
            label: 'Organization Admin',
            description: 'Ability to manage all athletes in the organization. Ability to manage coaches in the organization. Ability to promote other coaches to organization admin.',
            rolesAllowedToSelectThisOption: ['super-admin', 'organization-owner', 'organization-admin']
        },
        {
            key: 'trainer',
            label: 'Coach',
            description: 'Can only manage athletes assgined to them. Cannot manage other coaches. Cannot manage organization settings.',
            rolesAllowedToSelectThisOption: ['super-admin', 'organization-owner', 'organization-admin']
        }
    ]

    const filteredRoleOptions = roleOptions.filter(roleOption => {
        return roleOption.rolesAllowedToSelectThisOption.includes(userType)
    })

    return filteredRoleOptions
}

export const GetOrganizationSettingsOptions = (userType) => {

    const settingsOptions = [
        {
            title: 'Organization Info',
            description: 'Update your organization\'s name, website, logo, etc.',
            route: '/settings/details',
            rolesAllowedToSeeThisOption: ['super-admin', 'organization-admin', 'organization-owner'],
        },
        {
            title: 'Billing',
            description: 'Preview upcoming bill, manage your organization payment settings, etc.',
            route: '/settings/billing',
            rolesAllowedToSeeThisOption: ['super-admin', 'organization-admin', 'organization-owner'],
        },
        {
            title: 'Integrations',
            description: 'Connect your account to third party platforms',
            route: '/settings/integrations',
            rolesAllowedToSeeThisOption: ['super-admin', 'organization-admin', 'organization-owner', 'trainer'],
        }
    ]

    const filteredSettingsOptions = settingsOptions.filter(settingOption => {
        return settingOption.rolesAllowedToSeeThisOption.includes(userType)
    })

    return filteredSettingsOptions
    
}
